import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getNewsAll(Redis, sectionId, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/news/getNewsAll?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async fetchSections(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/news/getSections?isActions=true`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getNewsDetail(Redis, code, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/news/getNewsDetailNew?code=${code}`,
      reset,
    );
  },
});
